var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "flex mobile:flex-col tablet:flex-row flex-wrap w-full" },
    _vm._l(_vm.clients, function(entry, index) {
      return _c(
        "li",
        {
          key: index,
          staticClass: "block mb-2 mobile:w-full tablet:w-1/2",
          attrs: { "aria-label": _vm.$t("A11Y.CLIENT", entry) }
        },
        [
          _c(
            "a",
            {
              staticClass:
                "flex items-center w-full p-2 hover:bg-gray-200 rounded-sm cursor-pointer",
              style: _vm.font,
              attrs: {
                rel: "noopener",
                target: "_blank",
                href: entry.rss ? null : entry.link
              },
              on: {
                click: function($event) {
                  return _vm.onClick(entry)
                }
              }
            },
            [
              _c("span", { staticClass: "block w-6 mr-2" }, [
                entry.icon
                  ? _c("img", {
                      attrs: { "aria-hidden": "true", src: entry.icon }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "mr-2" }, [
                _vm._v(_vm._s(entry.title))
              ]),
              _vm._v(" "),
              _c("icon", { attrs: { type: "arrow-to-right" } })
            ],
            1
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }